import React, { ComponentProps } from "react";
import MarkdownView from "./MarkdownView";
import Modal, { ModalSize } from "./Modal";
import StackHeader from "./StackHeader";
import VStack from "../ui_atoms/VStack";
import Headline from "./Headline";
import { MenuAction } from "./HeaderActions";

type SmallModalProps = ComponentProps<typeof Modal> & {
    titlePrefix?: string;
    title: string;
};

const SmallModal = ({ titlePrefix, title, children, onClose, ...props }: SmallModalProps) => {
    return (
        <Modal
            size={ModalSize.small}
            animationType="slide"
            onClose={onClose}
            onRequestClose={onClose}
            {...props}
        >
            <StackHeader
                title={title}
                actions={
                    onClose ? ([{ icon: "close", onPress: onClose }] as MenuAction[]) : undefined
                }
            />
            <VStack h="2/3">
                {titlePrefix && <Headline h="2">{titlePrefix}</Headline>}
                {children}
            </VStack>
        </Modal>
    );
};

type SmallModalMarkdownProps = {
    markdown: string;
};

const Markdown = ({ markdown }: SmallModalMarkdownProps) => <MarkdownView markdown={markdown} />;

export default Object.assign(SmallModal, { Markdown });
